.ImgAvatar {
  background-color: transparent;
  background-position: center center;
  background-repeat: no-repeat;
  background-size: cover;
  height: 100%;
  width: 100%;
}

.UserAvatar {
  align-items: center;
  display: inline-flex;
  font-family: var(--rv-font-ui);
  font-weight: var(--rv-w-medium);
  justify-content: center;
  overflow: hidden;

  &.default {
    background-color: var(--rv-accent);
    color: var(--rv-accent-ink-deep);
  }

  &.grey {
    background-color: var(--rv-neutral-200);
    color: var(--rv-fg-2);
  }

  &.orange {
    background-color: var(--rv-warning);
    color: var(--white);
  }

  &.rounded {
    border-radius: 50%;
  }

  &.square {
    border-radius: var(--rv-radius-md);
  }

  &.tiny {
    font-size: var(--rv-text-xxs);
    height: var(--rv-icon-xs);
    min-width: var(--rv-icon-xs);
    width: var(--rv-icon-xs);
  }

  &.xsmall {
    font-size: var(--rv-text-xxs);
    height: var(--rv-icon-sm);
    min-width: var(--rv-icon-sm);
    width: var(--rv-icon-sm);
  }

  &.small {
    font-size: var(--rv-text-xxs);
    font-weight: var(--rv-w-regular);
    height: var(--rv-icon-md);
    min-width: var(--rv-icon-md);
    width: var(--rv-icon-md);
  }

  &.medium {
    flex: 0 0 auto;
    font-size: var(--rv-text-xs);
    height: var(--rv-icon-lg);
    min-height: var(--rv-icon-lg);
    width: var(--rv-icon-lg);
  }

  &.large {
    font-size: var(--rv-text-md);
    height: var(--rv-icon-xl);
    min-width: var(--rv-icon-xl);
    width: var(--rv-icon-xl);
  }

  &.xlarge {
    font-size: var(--rv-text-xl);
    height: var(--rv-icon-2xl);
    min-width: var(--rv-icon-2xl);
    width: var(--rv-icon-2xl);
  }

  &.xxlarge {
    font-size: var(--rv-text-xl);
    height: var(--rv-icon-2xl);
    min-width: var(--rv-icon-2xl);
    width: var(--rv-icon-2xl);
  }

  &.xxxlarge {
    font-size: var(--rv-text-2xl);
    height: var(--rv-icon-3xl);
    min-width: var(--rv-icon-3xl);
    width: var(--rv-icon-3xl);
  }
}
